export const wordKnowledgeData = [
  {
    id: 1,
    text: "Supplant most nearly means:",
    options: ["Amplify", "Clarify", "Uproot", "Stabilize"],
    correct: 2,
    explanation: "To supplant means to take the place of or uproot something."
  },
  {
    id: 2,
    text: "Vagary most nearly means:",
    options: ["Limitless", "Wispy", "Capable", "Caprice"],
    correct: 3,
    explanation: "A vagary is an unpredictable or whimsical idea or action, similar to a caprice."
  },
  {
    id: 3,
    text: "Calamari most nearly means:",
    options: ["Shamu", "Digit", "Squid", "Matrimony"],
    correct: 2,
    explanation: "Calamari is a dish made from squid."
  },
  {
    id: 4,
    text: "Lethargic most nearly means:",
    options: ["Apathetic", "Cozy", "Bouncy", "Deadly"],
    correct: 0,
    explanation: "Lethargic means sluggish or without energy, similar to apathetic."
  },
  {
    id: 5,
    text: "Teensy most nearly means:",
    options: ["Adolescent", "Immature", "Tiny", "Feminine"],
    correct: 2,
    explanation: "Teensy means very small or tiny."
  },
  {
    id: 6,
    text: "Audible most nearly means:",
    options: ["Visible", "Heard", "Silent", "Distant"],
    correct: 1,
    explanation: "Audible means capable of being heard."
  },
  {
    id: 7,
    text: "Eloquent most nearly means:",
    options: ["Graceful", "Silent", "Persuasive", "Vague"],
    correct: 2,
    explanation: "Eloquent refers to fluent and persuasive speech."
  },
  {
    id: 8,
    text: "Imminent most nearly means:",
    options: ["Faraway", "Pending", "Avoidable", "Impossible"],
    correct: 1,
    explanation: "Imminent means about to happen or forthcoming."
  },
  {
    id: 9,
    text: "Diligent most nearly means:",
    options: ["Careless", "Hardworking", "Impatient", "Curious"],
    correct: 1,
    explanation: "Diligent describes someone who works carefully and persistently."
  },
  {
    id: 10,
    text: "Trivial most nearly means:",
    options: ["Important", "Minor", "Complex", "Ancient"],
    correct: 1,
    explanation: "Trivial means of little value or importance."
  },
  {
    id: 11,
    text: "Verbose most nearly means:",
    options: ["Wordy", "Quiet", "Strong", "Thoughtful"],
    correct: 0,
    explanation: "Verbose means using more words than necessary; wordy."
  },
  {
    id: 12,
    text: "Tenacious most nearly means:",
    options: ["Forgetful", "Determined", "Gentle", "Shy"],
    correct: 1,
    explanation: "Tenacious means holding firm or being persistent."
  },
  {
    id: 13,
    text: "Benevolent most nearly means:",
    options: ["Kind", "Wealthy", "Clever", "Dangerous"],
    correct: 0,
    explanation: "Benevolent means kind or charitable."
  },
  {
    id: 14,
    text: "Ominous most nearly means:",
    options: ["Threatening", "Peaceful", "Bright", "Dull"],
    correct: 0,
    explanation: "Ominous means giving the impression something bad is going to happen."
  },
  {
    id: 15,
    text: "Candid most nearly means:",
    options: ["Hidden", "Honest", "Angry", "Uncertain"],
    correct: 1,
    explanation: "Candid means truthful and straightforward."
  },
  {
    id: 16,
    text: "Succinct most nearly means:",
    options: ["Brief", "Elaborate", "Tense", "Polite"],
    correct: 0,
    explanation: "Succinct means expressed clearly and briefly."
  },
  {
    id: 17,
    text: "Obsolete most nearly means:",
    options: ["Outdated", "Current", "Broken", "Rare"],
    correct: 0,
    explanation: "Obsolete means no longer in use or out of date."
  },
  {
    id: 18,
    text: "Aloof most nearly means:",
    options: ["Lively", "Friendly", "Engaged", "Distant"],
    correct: 3,
    explanation: "Aloof means emotionally detached or distant."
  },
  {
    id: 19,
    text: "Docile most nearly means:",
    options: ["Submissive", "Wild", "Clever", "Proud"],
    correct: 0,
    explanation: "Docile means easily taught or managed; submissive."
  },
  {
    id: 20,
    text: "Frugal most nearly means:",
    options: ["Generous", "Careful", "Wealthy", "Extravagant"],
    correct: 1,
    explanation: "Frugal means economical or avoiding waste."
  },
  {
    id: 21,
    text: "Copious most nearly means:",
    options: ["Sparse", "Abundant", "Ordinary", "Limited"],
    correct: 1,
    explanation: "Copious means large in quantity or plentiful."
  },
  {
    id: 22,
    text: "Prudent most nearly means:",
    options: ["Reckless", "Lucky", "Anxious", "Careful"],
    correct: 3,
    explanation: "Prudent means acting with care and thought for the future."
  },
  {
    id: 23,
    text: "Jubilant most nearly means:",
    options: ["Sad", "Joyful", "Tired", "Cautious"],
    correct: 1,
    explanation: "Jubilant means showing great happiness or triumph."
  },
  {
    id: 24,
    text: "Nefarious most nearly means:",
    options: ["Evil", "Boring", "Sneaky", "Loyal"],
    correct: 0,
    explanation: "Nefarious means wicked or criminal."
  },
  {
    id: 25,
    text: "Meticulous most nearly means:",
    options: ["Careless", "Thorough", "Fast", "Secretive"],
    correct: 1,
    explanation: "Meticulous means showing great attention to detail."
  },
  {
    id: 26,
    text: "Vicarious most nearly means:",
    options: ["Honest", "Indirect", "Unique", "Tangible"],
    correct: 1,
    explanation: "Vicarious means experienced through the feelings or actions of another person."
  },
  {
    id: 27,
    text: "Erudite most nearly means:",
    options: ["Clumsy", "Forgetful", "Learned", "Noisy"],
    correct: 2,
    explanation: "Erudite describes someone who is very knowledgeable or scholarly."
  },
  {
    id: 28,
    text: "Ostentatious most nearly means:",
    options: ["Reserved", "Calm", "Humble", "Showy"],
    correct: 3,
    explanation: "Ostentatious means characterized by vulgar or pretentious display."
  },
  {
    id: 29,
    text: "Impetuous most nearly means:",
    options: ["Hasty", "Patient", "Careful", "Planned"],
    correct: 0,
    explanation: "Impetuous means acting quickly without thought or care."
  },
  {
    id: 30,
    text: "Audible most nearly means:",
    options: ["Visible", "Hidden", "Heard", "Faint"],
    correct: 2,
    explanation: "Audible means able to be heard."
  },
  {
    id: 31,
    text: "Benevolent most nearly means:",
    options: ["Lazy", "Kind", "Proud", "Sad"],
    correct: 1,
    explanation: "Benevolent means well-meaning and kindly."
  },
  {
    id: 32,
    text: "Tenacious most nearly means:",
    options: ["Forgetful", "Casual", "Calm", "Persistent"],
    correct: 3,
    explanation: "Tenacious means holding firmly or determined."
  },
  {
    id: 33,
    text: "Eloquent most nearly means:",
    options: ["Persuasive", "Quiet", "Dull", "Boastful"],
    correct: 0,
    explanation: "Eloquent means fluent or persuasive in speaking or writing."
  },
  {
    id: 34,
    text: "Meticulous most nearly means:",
    options: ["Lazy", "Careful", "Careless", "Fast"],
    correct: 1,
    explanation: "Meticulous means showing great attention to detail."
  },
  {
    id: 35,
    text: "Cursory most nearly means:",
    options: ["Detailed", "Perfect", "Hasty", "Thorough"],
    correct: 2,
    explanation: "Cursory means performed quickly and without attention to detail."
  },
  {
    id: 36,
    text: "Transient most nearly means:",
    options: ["Permanent", "Important", "Recurring", "Temporary"],
    correct: 3,
    explanation: "Transient means lasting only for a short time."
  },
  {
    id: 37,
    text: "Conspicuous most nearly means:",
    options: ["Noticeable", "Hidden", "Quiet", "Subtle"],
    correct: 0,
    explanation: "Conspicuous means standing out so as to be clearly visible."
  },
  {
    id: 38,
    text: "Docile most nearly means:",
    options: ["Wild", "Obedient", "Unruly", "Aggressive"],
    correct: 1,
    explanation: "Docile means ready to accept control or instruction; submissive."
  },
  {
    id: 39,
    text: "Obsolete most nearly means:",
    options: ["Modern", "Common", "Outdated", "Efficient"],
    correct: 2,
    explanation: "Obsolete means no longer produced or used; out of date."
  },
  {
    id: 40,
    text: "Ambiguous most nearly means:",
    options: ["Certain", "Simple", "Direct", "Unclear"],
    correct: 3,
    explanation: "Ambiguous means open to more than one interpretation."
  },
  {
    id: 41,
    text: "Scrutinize most nearly means:",
    options: ["Examine closely", "Ignore", "Forget", "Reject"],
    correct: 0,
    explanation: "Scrutinize means to inspect or examine closely and thoroughly."
  },
  {
    id: 42,
    text: "Diligent most nearly means:",
    options: ["Tired", "Hardworking", "Lazy", "Confused"],
    correct: 1,
    explanation: "Diligent means showing care and conscientiousness in work."
  },
  {
    id: 43,
    text: "Frugal most nearly means:",
    options: ["Generous", "Wasteful", "Thrifty", "Rich"],
    correct: 2,
    explanation: "Frugal means economical or careful with money."
  },
  {
    id: 44,
    text: "Lucid most nearly means:",
    options: ["Dark", "Hazy", "Dull", "Clear"],
    correct: 3,
    explanation: "Lucid means expressed clearly or easy to understand."
  },
  {
    id: 45,
    text: "Candid most nearly means:",
    options: ["Honest", "Deceptive", "Quiet", "Formal"],
    correct: 0,
    explanation: "Candid means truthful and straightforward."
  },
  {
    id: 46,
    text: "Voracious most nearly means:",
    options: ["Sleepy", "Hungry", "Careful", "Bored"],
    correct: 1,
    explanation: "Voracious means having a very eager approach to an activity, often eating."
  },
  {
    id: 47,
    text: "Mundane most nearly means:",
    options: ["Exciting", "Extravagant", "Ordinary", "Unique"],
    correct: 2,
    explanation: "Mundane means lacking interest or excitement; dull."
  },
  {
    id: 48,
    text: "Perilous most nearly means:",
    options: ["Safe", "Calm", "Stable", "Dangerous"],
    correct: 3,
    explanation: "Perilous means full of danger or risk."
  },
  {
    id: 49,
    text: "Nostalgia most nearly means:",
    options: ["Longing", "Hatred", "Anger", "Contentment"],
    correct: 0,
    explanation: "Nostalgia means sentimental longing for the past."
  },
  {
    id: 50,
    text: "Melancholy most nearly means:",
    options: ["Happiness", "Sadness", "Anger", "Fear"],
    correct: 1,
    explanation: "Melancholy means a feeling of deep sadness or sorrow."
  },
  {
    id: 51,
    text: "Incessant most nearly means:",
    options: ["Occasional", "Rare", "Continuous", "Limited"],
    correct: 2,
    explanation: "Incessant means continuing without interruption."
  },
  {
    id: 52,
    text: "Imminent most nearly means:",
    options: ["Cancelled", "Delayed", "Past", "About to happen"],
    correct: 3,
    explanation: "Imminent means likely to occur at any moment."
  },
  {
    id: 53,
    text: "Elated most nearly means:",
    options: ["Overjoyed", "Sad", "Angry", "Nervous"],
    correct: 0,
    explanation: "Elated means extremely happy or proud."
  },
  {
    id: 54,
    text: "Hinder most nearly means:",
    options: ["Assist", "Obstruct", "Promote", "Advance"],
    correct: 1,
    explanation: "Hinder means to make it difficult for something to happen."
  },
  {
    id: 55,
    text: "Adversity most nearly means:",
    options: ["Luck", "Opportunity", "Hardship", "Wealth"],
    correct: 2,
    explanation: "Adversity means difficulties or misfortune."
  },
  {
    id: 56,
    text: "Barren most nearly means:",
    options: ["Fruitful", "Rich", "Growing", "Unproductive"],
    correct: 3,
    explanation: "Barren means unable to produce results or offspring."
  },
  {
    id: 57,
    text: "Resilient most nearly means:",
    options: ["Adaptable", "Rigid", "Weak", "Fragile"],
    correct: 0,
    explanation: "Resilient means able to recover quickly from difficulties."
  },
  {
    id: 58,
    text: "Tangible most nearly means:",
    options: ["Imaginary", "Real", "Hidden", "Unclear"],
    correct: 1,
    explanation: "Tangible means perceptible by touch or real and concrete."
  },
  {
    id: 59,
    text: "Deviate most nearly means:",
    options: ["Follow", "Return", "Depart", "Repeat"],
    correct: 2,
    explanation: "Deviate means to depart from an established course."
  },
  {
    id: 60,
    text: "Empathy most nearly means:",
    options: ["Hatred", "Judgment", "Fear", "Understanding"],
    correct: 3,
    explanation: "Empathy means the ability to understand and share another's feelings."
  },
  {
    id: 61,
    text: "Eminent most nearly means:",
    options: ["Distinguished", "Ordinary", "Unknown", "Silent"],
    correct: 0,
    explanation: "Eminent means famous or respected within a profession."
  },
  {
    id: 62,
    text: "Reverence most nearly means:",
    options: ["Disdain", "Respect", "Criticism", "Mockery"],
    correct: 1,
    explanation: "Reverence means deep respect for someone or something."
  },
  {
    id: 63,
    text: "Formidable most nearly means:",
    options: ["Easy", "Weak", "Intimidating", "Trivial"],
    correct: 2,
    explanation: "Formidable means inspiring fear or respect through being impressive."
  },
  {
    id: 64,
    text: "Timid most nearly means:",
    options: ["Bold", "Talkative", "Friendly", "Shy"],
    correct: 3,
    explanation: "Timid means showing a lack of courage or confidence."
  },
  {
    id: 65,
    text: "Pragmatic most nearly means:",
    options: ["Practical", "Idealistic", "Dreamy", "Naive"],
    correct: 0,
    explanation: "Pragmatic means dealing with things sensibly and realistically."
  },
  {
    id: 66,
    text: "Cohesive most nearly means:",
    options: ["Divided", "Unified", "Chaotic", "Fragmented"],
    correct: 1,
    explanation: "Cohesive means forming a united whole."
  },
  {
    id: 67,
    text: "Scrupulous most nearly means:",
    options: ["Careless", "Dishonest", "Honest", "Lazy"],
    correct: 2,
    explanation: "Scrupulous means acting with great moral integrity and being extremely careful to do what is considered right."
  },
  {
    id: 68,
    text: "Oblivious most nearly means:",
    options: ["Alert", "Cautious", "Attentive", "Unaware"],
    correct: 3,
    explanation: "Oblivious means not aware of or concerned about what is happening."
  },
  {
    id: 69,
    text: "Prolific most nearly means:",
    options: ["Productive", "Sparse", "Limited", "Slow"],
    correct: 0,
    explanation: "Prolific means producing much fruit, foliage, or many works."
  },
  {
    id: 70,
    text: "Cynical most nearly means:",
    options: ["Hopeful", "Distrustful", "Optimistic", "Joyful"],
    correct: 1,
    explanation: "Cynical means believing that people are motivated purely by self-interest."
  },
  {
    id: 71,
    text: "Impartial most nearly means:",
    options: ["Biased", "Partial", "Fair", "Favoring"],
    correct: 2,
    explanation: "Impartial means treating all rivals or disputants equally."
  },
  {
    id: 72,
    text: "Erratic most nearly means:",
    options: ["Stable", "Consistent", "Balanced", "Unpredictable"],
    correct: 3,
    explanation: "Erratic means not even or regular in pattern or movement."
  },
  {
    id: 73,
    text: "Apathy most nearly means:",
    options: ["Indifference", "Passion", "Fear", "Excitement"],
    correct: 0,
    explanation: "Apathy means lack of interest or concern."
  },
  {
    id: 74,
    text: "Alleviate most nearly means:",
    options: ["Intensify", "Relieve", "Burden", "Complicate"],
    correct: 1,
    explanation: "Alleviate means to make suffering or a problem less severe."
  },
  {
    id: 75,
    text: "Abstain most nearly means:",
    options: ["Indulge", "Consume", "Refrain", "Accept"],
    correct: 2,
    explanation: "Abstain means to restrain oneself from doing or enjoying something."
  },
  {
    id: 76,
    text: "ADMIRE is to RESPECT as DETEST is to",
    options: ["LOVE", "HATE", "FEAR", "TOLERATE", "AVOID"],
    correct: 1,
    explanation: "To ADMIRE someone is to RESPECT them; to DETEST someone is to HATE them."
  },
  {
    id: 77,
    text: "MOUNTAIN is to ELEVATION as VALLEY is to",
    options: ["DEPTH", "PEAK", "RIDGE", "PLAIN", "HEIGHT"],
    correct: 0,
    explanation: "A MOUNTAIN has high ELEVATION; a VALLEY has great DEPTH."
  },
  {
    id: 78,
    text: "FIRE is to HEAT as ICE is to",
    options: ["COLD", "FREEZE", "CHILL", "FROST", "WATER"],
    correct: 0,
    explanation: "FIRE produces HEAT; ICE produces COLD."
  },
  {
    id: 79,
    text: "NOVEL is to AUTHOR as SYMPHONY is to",
    options: ["CONDUCTOR", "MUSICIAN", "COMPOSER", "BAND", "INSTRUMENT"],
    correct: 2,
    explanation: "An AUTHOR writes a NOVEL; a COMPOSER writes a SYMPHONY."
  },
  {
    id: 80,
    text: "FINGER is to HAND as TOE is to",
    options: ["FOOT", "LEG", "KNEE", "ANKLE", "SOLE"],
    correct: 0,
    explanation: "A FINGER is part of a HAND; a TOE is part of a FOOT."
  },
  {
    id: 81,
    text: "ENEMY is to HOSTILE as FRIEND is to",
    options: ["TRUST", "LOYAL", "KIND", "ALLY", "FRIENDLY"],
    correct: 4,
    explanation: "An ENEMY is HOSTILE; a FRIEND is FRIENDLY."
  },
  {
    id: 82,
    text: "PHOTOGRAPHER is to CAMERA as PAINTER is to",
    options: ["BRUSH", "PICTURE", "LIGHT", "COLOR", "FRAME"],
    correct: 0,
    explanation: "A PHOTOGRAPHER uses a CAMERA; a PAINTER uses a BRUSH."
  },
  {
    id: 83,
    text: "EXHAUSTED is to REST as HUNGRY is to",
    options: ["THIRST", "SATE", "FOOD", "DINNER", "COOK"],
    correct: 2,
    explanation: "One who is EXHAUSTED needs REST; one who is HUNGRY needs FOOD."
  },
  {
    id: 84,
    text: "DAY is to SUN as NIGHT is to",
    options: ["DARK", "MOON", "LIGHT", "STARS", "SLEEP"],
    correct: 1,
    explanation: "The SUN is seen during DAY; the MOON is seen at NIGHT."
  },
  {
    id: 85,
    text: "CAPTAIN is to SHIP as PILOT is to",
    options: ["JET", "FLIGHT", "PLANE", "AIR", "COCKPIT"],
    correct: 2,
    explanation: "A CAPTAIN commands a SHIP; a PILOT commands a PLANE."
  },
  {
    id: 86,
    text: "WHEEL is to CAR as WING is to",
    options: ["PLANE", "BIRD", "SKY", "JET", "AIR"],
    correct: 0,
    explanation: "A WHEEL helps a CAR move; a WING helps a PLANE move."
  },
  {
    id: 87,
    text: "DOOR is to HINGE as DRAWER is to",
    options: ["HANDLE", "KNOB", "DRESSER", "TRACK", "LOCK"],
    correct: 3,
    explanation: "A DOOR moves on a HINGE; a DRAWER slides on a TRACK."
  },
  {
    id: 88,
    text: "RAIN is to DROUGHT as LAUGHTER is to",
    options: ["HAPPINESS", "SADNESS", "JOY", "CONSTIPATION", "PAIN"],
    correct: 1,
    explanation: "RAIN is the opposite of DROUGHT; LAUGHTER is the opposite of SADNESS."
  },
  {
    id: 89,
    text: "PRISON is to CONVICT as SCHOOL is to",
    options: ["STUDENT", "TEACHER", "CLASS", "EDUCATION", "LEARNING"],
    correct: 0,
    explanation: "A CONVICT is kept in PRISON; a STUDENT attends SCHOOL."
  },
  {
    id: 90,
    text: "RAINBOW is to COLORS as CHORD is to",
    options: ["SOUNDS", "MUSIC", "INSTRUMENTS", "NOTES", "MELODY"],
    correct: 3,
    explanation: "A RAINBOW is made of COLORS; a CHORD is made of NOTES."
  },
  {
    id: 91,
    text: "SOLDIER is to ARMY as SAILOR is to",
    options: ["NAVY", "SEA", "BOAT", "CAPTAIN", "MARINE"],
    correct: 0,
    explanation: "A SOLDIER belongs to an ARMY; a SAILOR belongs to the NAVY."
  },
  {
    id: 92,
    text: "JUDGE is to COURT as TEACHER is to",
    options: ["LESSON", "CLASSROOM", "BOOK", "EXAM", "STUDENT"],
    correct: 1,
    explanation: "A JUDGE works in a COURT; a TEACHER works in a CLASSROOM."
  },
  {
    id: 93,
    text: "SPEAR is to THROW as BOW is to",
    options: ["STRING", "ARROW", "TARGET", "SHOOT", "AIM"],
    correct: 3,
    explanation: "You THROW a SPEAR; you SHOOT a BOW."
  },
  {
    id: 94,
    text: "CLOTH is to SHIRT as WOOD is to",
    options: ["TREE", "PAPER", "CHAIR", "FOREST", "CARPET"],
    correct: 2,
    explanation: "CLOTH is used to make a SHIRT; WOOD is used to make a CHAIR."
  },
  {
    id: 95,
    text: "HONEY is to BEES as SILK is to",
    options: ["COTTON", "WORM", "MAMMOTH", "MOTH", "COCOON"],
    correct: 1,
    explanation: "BEES produce HONEY; SILKWORMS produce SILK."
  },
  {
    id: 96,
    text: "TELESCOPE is to ASTRONOMER as MICROSCOPE is to",
    options: ["MECHANIC", "BIOLOGIST", "SOLDIER", "PILOT", "RESEARCHER"],
    correct: 1,
    explanation: "An ASTRONOMER uses a TELESCOPE; a BIOLOGIST uses a MICROSCOPE."
  },
  {
    id: 97,
    text: "FUEL is to ENGINE as FOOD is to",
    options: ["BODY", "ENERGY", "STOMACH", "LIFE", "HEALTH"],
    correct: 0,
    explanation: "FUEL powers an ENGINE; FOOD powers the BODY."
  },
  {
    id: 98,
    text: "LAWYER is to CLIENT as DOCTOR is to",
    options: ["PATIENT", "NURSE", "MEDICINE", "CASE", "HOSPITAL"],
    correct: 0,
    explanation: "A LAWYER serves a CLIENT; a DOCTOR serves a PATIENT."
  },
  {
    id: 99,
    text: "GRAIN is to WHEAT as GEM is to",
    options: ["JEWEL", "STONE", "DIAMOND", "ROCK", "MINERAL"],
    correct: 2,
    explanation: "WHEAT is a type of GRAIN; a DIAMOND is a type of GEM."
  },
  {
    id: 100,
    text: "AUTHOR is to WORDS as PAINTER is to",
    options: ["CANVAS", "PICTURE", "COLORS", "ROLLER", "IMAGE"],
    correct: 2,
    explanation: "An AUTHOR works with WORDS; an PAINTER works with COLORS."
  },
  {
    id: 101,
    text: "GREGARIOUS",
    options: ["shy", "isolated", "indifferent", "sociable", "moody"],
    correct: 3,
    explanation: "Gregarious means sociable or fond of company."
  },
  {
    id: 102,
    text: "OBSTINATE",
    options: ["flexible", "gentle", "stubborn", "open-minded", "curious"],
    correct: 2,
    explanation: "Obstinate means stubborn or unwilling to change one's opinion."
  },
  {
    id: 103,
    text: "MAGNANIMOUS",
    options: ["greedy", "petty", "boastful", "generous", "arrogant"],
    correct: 3,
    explanation: "Magnanimous means generous or forgiving, especially toward a rival."
  },
  {
    id: 104,
    text: "LUGUBRIOUS",
    options: ["sad", "cheerful", "dry", "energetic", "formal"],
    correct: 0,
    explanation: "Lugubrious means mournful or gloomy."
  },
  {
    id: 105,
    text: "TACITURN",
    options: ["talkative", "open", "quiet", "humorous", "energetic"],
    correct: 2,
    explanation: "Taciturn means reserved or uncommunicative in speech."
  },
  {
    id: 106,
    text: "QUELL",
    options: ["encourage", "question", "reveal", "suppress", "sustain"],
    correct: 3,
    explanation: "Quell means to suppress or put an end to something."
  },
  {
    id: 107,
    text: "ABSTRUSE",
    options: ["clear", "complex", "pleasant", "soft", "trivial"],
    correct: 1,
    explanation: "Abstruse means difficult to understand."
  },
  {
    id: 108,
    text: "INSOLENT",
    options: ["respectful", "quiet", "rude", "lazy", "timid"],
    correct: 2,
    explanation: "Insolent means showing a rude and arrogant lack of respect."
  },
  {
    id: 109,
    text: "PERFUNCTORY",
    options: ["thorough", "enthusiastic", "rare", "routine", "careless"],
    correct: 3,
    explanation: "Perfunctory means done routinely with little interest or effort."
  },
  {
    id: 110,
    text: "EPHEMERAL",
    options: ["brief", "lasting", "slow", "permanent", "thick"],
    correct: 0,
    explanation: "Ephemeral means short-lived or temporary."
  },
  {
    id: 111,
    text: "VINDICATE",
    options: ["accuse", "condemn", "justify", "destroy", "question"],
    correct: 2,
    explanation: "Vindicate means to clear from blame or justify."
  },
  {
    id: 112,
    text: "ENERVATE",
    options: ["strengthen", "energize", "excite", "weaken", "repair"],
    correct: 3,
    explanation: "Enervate means to weaken or drain energy from."
  },
  {
    id: 113,
    text: "TRANSITION",
    options: ["phase", "obstruct", "stop", "adhere", "deter"],
    correct: 0,
    explanation: "Transition means a change from one state to another."
  },
  {
    id: 114,
    text: "BENEVOLENT",
    options: ["selfish", "kind", "lazy", "angry", "bitter"],
    correct: 1,
    explanation: "Benevolent means kind or charitable."
  },
  {
    id: 115,
    text: "SURLY",
    options: ["polite", "cheerful", "quiet", "irritable", "sleepy"],
    correct: 3,
    explanation: "Surly means bad-tempered or unfriendly."
  },
  {
    id: 116,
    text: "LAMENT",
    options: ["mourn", "celebrate", "ignore", "delay", "forgive"],
    correct: 0,
    explanation: "Lament means to mourn or express grief."
  },
  {
    id: 117,
    text: "OBSCURE",
    options: ["bright", "hidden", "famous", "visible", "plain"],
    correct: 1,
    explanation: "Obscure means not easily seen, hidden, or unclear."
  },
  {
    id: 118,
    text: "ADULATION",
    options: ["criticism", "disgust", "praise", "complaint", "indifference"],
    correct: 2,
    explanation: "Adulation means excessive praise or admiration."
  },
  {
    id: 119,
    text: "CANDOR",
    options: ["deception", "wit", "silence", "honesty", "suspicion"],
    correct: 3,
    explanation: "Candor means openness or honesty in expression."
  },
  {
    id: 120,
    text: "FASTIDIOUS",
    options: ["meticulous", "careless", "rushed", "sloppy", "lazy"],
    correct: 0,
    explanation: "Fastidious means very attentive to detail or cleanliness."
  },
  {
    id: 121,
    text: "CREDULOUS",
    options: ["skeptical", "wise", "gullible", "clever", "doubtful"],
    correct: 2,
    explanation: "Credulous means too ready to believe things — gullible."
  },
  {
    id: 122,
    text: "RELINQUISH",
    options: ["obtain", "hide", "grasp", "surrender", "maintain"],
    correct: 3,
    explanation: "Relinquish means to give up or surrender something."
  },
  {
    id: 123,
    text: "AUSTERE",
    options: ["luxurious", "strict", "simple", "polished", "gentle"],
    correct: 1,
    explanation: "Austere means strict or severe in manner or appearance."
  },
  {
    id: 124,
    text: "FERVENT",
    options: ["cold", "neutral", "passionate", "mild", "apathetic"],
    correct: 2,
    explanation: "Fervent means displaying intense passion or enthusiasm."
  },
  {
    id: 125,
    text: "MALADROIT",
    options: ["skillful", "wise", "graceful", "clumsy", "careful"],
    correct: 3,
    explanation: "Maladroit means clumsy or awkward."
  },
  {
    id: 126,
    text: "NEBULOUS",
    options: ["vague", "clear", "bright", "distinct", "obvious"],
    correct: 0,
    explanation: "Nebulous means vague or unclear."
  },
  {
    id: 127,
    text: "OBVIATE",
    options: ["create", "remove", "allow", "progess", "ignore"],
    correct: 1,
    explanation: "Obviate means to remove or prevent a need or difficulty."
  },
  {
    id: 128,
    text: "QUERULOUS",
    options: ["cheerful", "quiet", "complaining", "happy", "agreeable"],
    correct: 2,
    explanation: "Querulous means complaining or whining."
  },
  {
    id: 129,
    text: "IMPETUOUS",
    options: ["careful", "slow", "calm", "impulsive", "thoughtful"],
    correct: 3,
    explanation: "Impetuous means acting quickly without thought or care."
  },
  {
    id: 130,
    text: "RECALCITRANT",
    options: ["stubborn", "obedient", "energetic", "tired", "forgetful"],
    correct: 0,
    explanation: "Recalcitrant means stubbornly disobedient or resistant to authority."
  },
  {
    id: 131,
    text: "SAGACIOUS",
    options: ["foolish", "lazy", "wise", "naïve", "clumsy"],
    correct: 2,
    explanation: "Sagacious means having keen mental discernment and good judgment."
  },
  {
    id: 132,
    text: "TENACIOUS",
    options: ["weak", "inattentive", "timid", "persistent", "carefree"],
    correct: 3,
    explanation: "Tenacious means holding firmly or being very determined."
  },
  {
    id: 133,
    text: "JUXTAPOSE",
    options: ["compare side by side", "separate", "replace", "hide", "ignore"],
    correct: 0,
    explanation: "Juxtapose means to place things side by side for comparison."
  },
  {
    id: 134,
    text: "HAPLESS",
    options: ["fortunate", "cheerful", "unlucky", "wealthy", "hopeful"],
    correct: 2,
    explanation: "Hapless means unfortunate or unlucky."
  },
  {
    id: 135,
    text: "MITIGATE",
    options: ["worsen", "ignore", "expand", "lessen", "delay"],
    correct: 3,
    explanation: "Mitigate means to make less severe or intense."
  },
  {
    id: 136,
    text: "SPURIOUS",
    options: ["false", "genuine", "rare", "vivid", "predictable"],
    correct: 0,
    explanation: "Spurious means false or not genuine."
  },
  {
    id: 137,
    text: "ABERRATION",
    options: ["normality", "deviation", "habit", "rule", "pattern"],
    correct: 1,
    explanation: "Aberration means a deviation from what is normal or expected."
  },
  {
    id: 138,
    text: "INTRANSIGENT",
    options: ["compromising", "confused", "unyielding", "uncertain", "gentle"],
    correct: 2,
    explanation: "Intransigent means unwilling to change one's views or to agree."
  },
  {
    id: 139,
    text: "LUCID",
    options: ["confusing", "dim", "chaotic", "clear", "faint"],
    correct: 3,
    explanation: "Lucid means clear or easy to understand."
  },
  {
    id: 140,
    text: "VORACIOUS",
    options: ["greedy", "satisfied", "slow", "gentle", "indifferent"],
    correct: 0,
    explanation: "Voracious means having a very eager approach to an activity or appetite."
  },
  {
    id: 141,
    text: "DISPARAGE",
    options: ["praise", "belittle", "improve", "support", "assist"],
    correct: 1,
    explanation: "Disparage means to belittle or speak of someone in a derogatory manner."
  },
  {
    id: 142,
    text: "EPITOME",
    options: ["extreme", "summary", "symbol", "example", "copy"],
    correct: 3,
    explanation: "Epitome means a perfect example of a quality or type."
  },
  {
    id: 143,
    text: "OBFUSCATE",
    options: ["clarify", "reveal", "simplify", "confuse", "summarize"],
    correct: 3,
    explanation: "Obfuscate means to confuse or make unclear."
  },
  {
    id: 144,
    text: "PLACATE",
    options: ["soothe", "anger", "ignore", "challenge", "reject"],
    correct: 0,
    explanation: "Placate means to calm or appease someone."
  },
  {
    id: 145,
    text: "NEFARIOUS",
    options: ["honorable", "wicked", "famous", "brave", "lawful"],
    correct: 1,
    explanation: "Nefarious means wicked or villainous."
  },
  {
    id: 146,
    text: "PROLIFIC",
    options: ["barren", "scarce", "productive", "limited", "narrow"],
    correct: 2,
    explanation: "Prolific means highly productive or creative."
  },
  {
    id: 147,
    text: "AMICABLE",
    options: ["hostile", "cold", "neutral", "friendly", "argumentative"],
    correct: 3,
    explanation: "Amicable means friendly or showing goodwill."
  },
  {
    id: 148,
    text: "FASTIDIOUS",
    options: ["attentive", "careless", "messy", "lazy", "easygoing"],
    correct: 0,
    explanation: "Fastidious means very attentive to detail or fussy."
  },
  {
    id: 149,
    text: "QUIXOTIC",
    options: ["practical", "idealistic", "boring", "rational", "stable"],
    correct: 1,
    explanation: "Quixotic means extremely idealistic or unrealistic."
  },
  {
    id: 150,
    text: "DEFERENCE",
    options: ["disrespect", "chaotic", "respect", "rebellion", "disapproval"],
    correct: 2,
    explanation: "Deference means humble submission and respect."
  },
  {
    id: 151,
    text: "INEFFABLE",
    options: ["common", "unexplainable", "ordinary", "expressive", "verbal"],
    correct: 1,
    explanation: "Ineffable means too great or extreme to be expressed in words."
  },
  {
    id: 152,
    text: "RETICENT",
    options: ["talkative", "open", "reserved", "confident", "honest"],
    correct: 2,
    explanation: "Reticent means not revealing one's thoughts or feelings readily."
  },
  {
    id: 153,
    text: "FECUND",
    options: ["infertile", "dry", "sterile", "fruitful", "barren"],
    correct: 3,
    explanation: "Fecund means capable of producing offspring or new growth; fertile."
  },
  {
    id: 154,
    text: "SANCTIMONIOUS",
    options: ["pious", "hypocritically moralistic", "genuine", "sinful", "humble"],
    correct: 1,
    explanation: "Sanctimonious means pretending to be morally superior."
  },
  {
    id: 155,
    text: "EQUIVOCAL",
    options: ["certain", "clear", "ambiguous", "specific", "focused"],
    correct: 2,
    explanation: "Equivocal means open to more than one interpretation; ambiguous."
  },
  {
    id: 156,
    text: "OBDURATE",
    options: ["soft", "flexible", "gentle", "stubborn", "weak"],
    correct: 3,
    explanation: "Obdurate means stubbornly refusing to change one's opinion."
  },
  {
    id: 157,
    text: "VERBOSE",
    options: ["concise", "wordy", "silent", "direct", "short"],
    correct: 1,
    explanation: "Verbose means using more words than necessary."
  },
  {
    id: 158,
    text: "TRANQUIL",
    options: ["restless", "loud", "calm", "busy", "noisy"],
    correct: 2,
    explanation: "Tranquil means calm and peaceful."
  },
  {
    id: 159,
    text: "INTREPID",
    options: ["cowardly", "nervous", "cautious", "fearless", "weak"],
    correct: 3,
    explanation: "Intrepid means fearless or adventurous."
  },
  {
    id: 160,
    text: "MENDACIOUS",
    options: ["deceitful", "honest", "truthful", "trustworthy", "sincere"],
    correct: 0,
    explanation: "Mendacious means lying or dishonest."
  },
  {
    id: 161,
    text: "BELLICOSE",
    options: ["peaceful", "warlike", "calm", "gentle", "relaxed"],
    correct: 1,
    explanation: "Bellicose means demonstrating aggression or a willingness to fight."
  },
  {
    id: 162,
    text: "ALACRITY",
    options: ["reluctance", "fear", "eagerness", "laziness", "disinterest"],
    correct: 2,
    explanation: "Alacrity means brisk and cheerful readiness."
  },
  {
    id: 163,
    text: "LACONIC",
    options: ["verbose", "flowery", "dramatic", "brief", "vague"],
    correct: 3,
    explanation: "Laconic means using very few words; concise."
  },
  {
    id: 164,
    text: "SOPORIFIC",
    options: ["sleep-inducing", "exciting", "energizing", "stimulating", "bright"],
    correct: 0,
    explanation: "Soporific means tending to induce sleep."
  },
  {
    id: 165,
    text: "ABATE",
    options: ["increase", "lessen", "continue", "harden", "begin"],
    correct: 1,
    explanation: "Abate means to reduce in degree or intensity."
  },
  {
    id: 166,
    text: "PROSAIC",
    options: ["creative", "exciting", "dull", "imaginative", "inspired"],
    correct: 2,
    explanation: "Prosaic means dull or lacking imagination."
  },
  {
    id: 167,
    text: "REPROVE",
    options: ["praise", "ignore", "forgive", "scold", "celebrate"],
    correct: 3,
    explanation: "Reprove means to scold or criticize gently."
  },
  {
    id: 168,
    text: "SANGUINE",
    options: ["optimistic", "pessimistic", "gloomy", "uncertain", "depressed"],
    correct: 0,
    explanation: "Sanguine means optimistic or positive, especially in difficult situations."
  },
  {
    id: 169,
    text: "INSCRUTABLE",
    options: ["obvious", "mysterious", "clear", "plain", "predictable"],
    correct: 1,
    explanation: "Inscrutable means impossible to understand or interpret."
  },
  {
    id: 170,
    text: "ZEALOUS",
    options: ["apathetic", "cold", "enthusiastic", "lazy", "neutral"],
    correct: 2,
    explanation: "Zealous means full of enthusiasm or zeal."
  },
  {
    id: 171,
    text: "MALAISE",
    options: ["comfort", "health", "contentment", "uneasiness", "excitement"],
    correct: 3,
    explanation: "Malaise means a general feeling of discomfort or unease."
  },
  {
    id: 172,
    text: "MUNIFICENT",
    options: ["generous", "stingy", "small", "moderate", "limited"],
    correct: 0,
    explanation: "Munificent means very generous or lavish."
  },
  {
    id: 173,
    text: "RECONDITE",
    options: ["simple", "obscure", "known", "basic", "clear"],
    correct: 1,
    explanation: "Recondite means little known or obscure."
  },
  {
    id: 174,
    text: "PARAGON",
    options: ["flaw", "opposite", "model", "failure", "copy"],
    correct: 2,
    explanation: "Paragon means a model of excellence or perfection."
  },
  {
    id: 175,
    text: "INDOLENT",
    options: ["active", "busy", "energetic", "lazy", "productive"],
    correct: 3,
    explanation: "Indolent means wanting to avoid activity; lazy."
  },
  {
    id: 176,
    text: "CONVIVIAL",
    options: ["friendly", "gloomy", "quiet", "angry", "hostile"],
    correct: 0,
    explanation: "Convivial means friendly, lively, and enjoyable."
  },
  {
    id: 177,
    text: "DISSEMINATE",
    options: ["collect", "spread", "ignore", "block", "limit"],
    correct: 1,
    explanation: "Disseminate means to spread or disperse widely."
  },
  {
    id: 178,
    text: "INNOCUOUS",
    options: ["harmful", "dangerous", "harmless", "toxic", "lethal"],
    correct: 2,
    explanation: "Innocuous means not harmful or offensive."
  },
  {
    id: 179,
    text: "EXCORIATE",
    options: ["praise", "ignore", "heal", "criticize", "reward"],
    correct: 3,
    explanation: "Excoriate means to criticize severely."
  },
  {
    id: 180,
    text: "CUPIDITY",
    options: ["greed", "generosity", "love", "honesty", "calm"],
    correct: 0,
    explanation: "Cupidity means greed for money or possessions."
  },
  {
    id: 181,
    text: "OSTENTATIOUS",
    options: ["modest", "showy", "plain", "humble", "simple"],
    correct: 1,
    explanation: "Ostentatious means characterized by vulgar or pretentious display."
  },
  {
    id: 182,
    text: "INSIDIOUS",
    options: ["harmless", "obvious", "sneaky", "direct", "kind"],
    correct: 2,
    explanation: "Insidious means proceeding in a subtle but harmful way."
  },
  {
    id: 183,
    text: "LUGUBRIOUS",
    options: ["cheerful", "serene", "hopeful", "sad", "bright"],
    correct: 3,
    explanation: "Lugubrious means mournful or gloomy in appearance or tone."
  },
  {
    id: 184,
    text: "REVERENT",
    options: ["respectful", "disrespectful", "loud", "careless", "angry"],
    correct: 0,
    explanation: "Reverent means feeling or showing deep respect."
  },
  {
    id: 185,
    text: "CLEMENCY",
    options: ["cruelty", "mercy", "revenge", "harshness", "justice"],
    correct: 1,
    explanation: "Clemency means mercy or leniency."
  },
  {
    id: 186,
    text: "PERSPICACIOUS",
    options: ["dim-witted", "forgetful", "shrewd", "sleepy", "bored"],
    correct: 2,
    explanation: "Perspicacious means having keen understanding or insight."
  },
  {
    id: 187,
    text: "IGNOMINIOUS",
    options: ["honorable", "famous", "kind", "disgraceful", "proud"],
    correct: 3,
    explanation: "Ignominious means deserving or causing public disgrace or shame."
  },
  {
    id: 188,
    text: "SUPERCILIOUS",
    options: ["arrogant", "humble", "quiet", "silly", "submissive"],
    correct: 0,
    explanation: "Supercilious means behaving as though one is superior to others."
  },
  {
    id: 189,
    text: "VERACITY",
    options: ["deception", "truthfulness", "anger", "cowardice", "modesty"],
    correct: 1,
    explanation: "Veracity means truthfulness or accuracy."
  },
  {
    id: 190,
    text: "IMPASSIVE",
    options: ["emotional", "calm", "sensitive", "indifferent", "angry"],
    correct: 3,
    explanation: "Impassive means not showing emotion or feeling."
  },
  {
    id: 191,
    text: "EUPHONIOUS",
    options: ["pleasant-sounding", "harsh", "discordant", "loud", "shrill"],
    correct: 0,
    explanation: "Euphonious means pleasing to the ear."
  },
  {
    id: 192,
    text: "INSOLVENT",
    options: ["wealthy", "bankrupt", "generous", "rich", "stable"],
    correct: 1,
    explanation: "Insolvent means unable to pay debts owed; bankrupt."
  },
  {
    id: 193,
    text: "PENURIOUS",
    options: ["wealthy", "lavish", "poor", "stingy", "frugal"],
    correct: 2,
    explanation: "Penurious means extremely poor or miserly."
  },
  {
    id: 194,
    text: "REBELLIOUS",
    options: ["obedient", "quiet", "helpful", "recalcitrant", "tame"],
    correct: 3,
    explanation: "Rebellious means having an obstinately uncooperative attitude or to be recalcitrant."
  },
  {
    id: 195,
    text: "DEARTH",
    options: ["scarcity", "abundance", "excess", "wealth", "supply"],
    correct: 0,
    explanation: "Dearth means a scarcity or lack of something."
  },
  {
    id: 196,
    text: "GARRULOUS",
    options: ["silent", "talkative", "quiet", "calm", "bashful"],
    correct: 1,
    explanation: "Garrulous means excessively talkative."
  },
  {
    id: 197,
    text: "DILATORY",
    options: ["speedy", "steady", "slow", "punctual", "eager"],
    correct: 2,
    explanation: "Dilatory means slow to act or intended to cause delay."
  },
  {
    id: 198,
    text: "SECONDHAND",
    options: ["direct", "original", "personal", "vicarious", "authentic"],
    correct: 3,
    explanation: "Secondhand means not the original source of experience."
  },
  {
    id: 199,
    text: "CAPRICIOUS",
    options: ["impulsive", "predictable", "steady", "calm", "logical"],
    correct: 0,
    explanation: "Capricious means given to sudden, unpredictable changes of mood or behavior."
  },
  {
    id: 200,
    text: "OBSEQUIOUS",
    options: ["arrogant", "submissive", "lazy", "honest", "careless"],
    correct: 1,
    explanation: "Obsequious means obedient or attentive to an excessive degree."
  },
  {
    id: 201,
    text: "The commander issued a **perfunctory** inspection of the barracks.",
    options: ["thorough", "casual", "military", "detailed", "strict"],
    correct: 1,
    explanation: "Perfunctory means carried out with minimal effort or reflection; routine and superficial."
  },
  {
    id: 202,
    text: "The pilot's decision proved to be **prudent** given the weather conditions.",
    options: ["reckless", "quick", "wise", "delayed", "uncertain"],
    correct: 2,
    explanation: "Prudent means acting with or showing care and thought for the future; wise and sensible."
  },
  {
    id: 203,
    text: "The sergeant's demeanor toward the recruits was **austere**.",
    options: ["friendly", "severe", "casual", "jovial", "lenient"],
    correct: 1,
    explanation: "Austere means severe or strict in manner, attitude, or appearance."
  },
  {
    id: 204,
    text: "They found the regulations to be **ambiguous** and difficult to follow.",
    options: ["clear", "simple", "unclear", "direct", "obvious"],
    correct: 2,
    explanation: "Ambiguous means open to more than one interpretation; not having one clear meaning."
  },
  {
    id: 205,
    text: "The mission required a **meticulous** approach to planning.",
    options: ["careless", "careful", "quick", "simple", "rough"],
    correct: 1,
    explanation: "Meticulous means showing great attention to detail; very careful and precise."
  },
  {
    id: 206,
    text: "His account of the incident was quite **verbose**.",
    options: ["brief", "wordy", "accurate", "false", "simple"],
    correct: 1,
    explanation: "Verbose means using or expressed in more words than are needed; wordy."
  },
  {
    id: 207,
    text: "The officer showed **clemency** in his judgment of the violation.",
    options: ["harshness", "mercy", "speed", "anger", "indifference"],
    correct: 1,
    explanation: "Clemency means mercy or lenience shown toward an offender or enemy."
  },
  {
    id: 208,
    text: "The briefing contained only **cursory** information about the operation.",
    options: ["detailed", "superficial", "secret", "complete", "accurate"],
    correct: 1,
    explanation: "Cursory means hasty and therefore not thorough or detailed."
  },
  {
    id: 209,
    text: "They needed to **expedite** the delivery of the supplies.",
    options: ["delay", "hasten", "cancel", "verify", "reduce"],
    correct: 1,
    explanation: "Expedite means to make an action or process happen sooner or be accomplished more quickly."
  },
  {
    id: 210,
    text: "The witness gave a **candid** response to all questions.",
    options: ["dishonest", "frank", "evasive", "lengthy", "technical"],
    correct: 1,
    explanation: "Candid means truthful and straightforward; frank."
  },
  {
    id: 211,
    text: "The squadron faced an **arduous** training exercise in the mountains.",
    options: ["easy", "difficult", "brief", "enjoyable", "optional"],
    correct: 1,
    explanation: "Arduous means involving or requiring strenuous effort; difficult and tiring."
  },
  {
    id: 212,
    text: "The general's strategy was deemed **ingenious** by his peers.",
    options: ["foolish", "clever", "simple", "traditional", "risky"],
    correct: 1,
    explanation: "Ingenious means clever, original, and inventive."
  },
  {
    id: 213,
    text: "The cadet's performance was **exemplary** throughout training.",
    options: ["poor", "outstanding", "average", "inconsistent", "adequate"],
    correct: 1,
    explanation: "Exemplary means serving as a desirable model; representing the best of its kind."
  },
  {
    id: 214,
    text: "The intelligence report contained information that was **paramount** to the mission.",
    options: ["irrelevant", "crucial", "interesting", "confidential", "recent"],
    correct: 1,
    explanation: "Paramount means more important than anything else; supreme."
  },
  {
    id: 215,
    text: "The officer remained **stoic** despite the difficult news.",
    options: ["emotional", "unemotional", "angry", "relieved", "surprised"],
    correct: 1,
    explanation: "Stoic means showing no emotion or complaint in the face of difficulty."
  },
  {
    id: 216,
    text: "The team showed remarkable **tenacity** in completing their objective.",
    options: ["weakness", "persistence", "speed", "skill", "courage"],
    correct: 1,
    explanation: "Tenacity means the quality of being determined and persistent."
  },
  {
    id: 217,
    text: "His explanation of the problem was quite **lucid**.",
    options: ["confusing", "clear", "lengthy", "technical", "boring"],
    correct: 1,
    explanation: "Lucid means expressed clearly; easy to understand."
  },
  {
    id: 218,
    text: "The airman's **negligence** resulted in equipment damage.",
    options: ["care", "carelessness", "expertise", "training", "experience"],
    correct: 1,
    explanation: "Negligence means failure to take proper care in doing something."
  },
  {
    id: 219,
    text: "They tried to **corroborate** the information with multiple sources.",
    options: ["deny", "confirm", "hide", "question", "ignore"],
    correct: 1,
    explanation: "Corroborate means to confirm or give support to a statement or theory."
  },
  {
    id: 220,
    text: "The platoon maintained a **vigorous** training schedule.",
    options: ["relaxed", "energetic", "flexible", "irregular", "brief"],
    correct: 1,
    explanation: "Vigorous means strong, healthy, and full of energy."
  },
  {
    id: 221,
    text: "The commander's orders were **unequivocal** and left no room for interpretation.",
    options: ["vague", "clear", "lengthy", "written", "verbal"],
    correct: 1,
    explanation: "Unequivocal means leaving no doubt; unambiguous."
  },
  {
    id: 222,
    text: "The soldier showed **remorse** for his actions during the inquiry.",
    options: ["pride", "regret", "anger", "confusion", "indifference"],
    correct: 1,
    explanation: "Remorse means deep regret or guilt for a wrong committed."
  },
  {
    id: 223,
    text: "The maintenance crew worked with **diligence** to repair the aircraft.",
    options: ["laziness", "carefulness", "speed", "difficulty", "reluctance"],
    correct: 1,
    explanation: "Diligence means careful and persistent work or effort."
  },
  {
    id: 224,
    text: "The enemy's tactics were considered **devious** and unpredictable.",
    options: ["honest", "deceitful", "simple", "obvious", "traditional"],
    correct: 1,
    explanation: "Devious means showing a skillful use of underhanded tactics to achieve goals."
  },
  {
    id: 225,
    text: "The lieutenant's demeanor was always **cordial** toward his subordinates.",
    options: ["hostile", "friendly", "professional", "distant", "strict"],
    correct: 1,
    explanation: "Cordial means warm and friendly."
  },
{
    id: 226,
    text: "The report highlighted a **conspicuous** error in the calculations.",
    options: ["hidden", "obvious", "minor", "technical", "mathematical"],
    correct: 1,
    explanation: "Conspicuous means standing out so as to be clearly visible; obvious."
  },
  {
    id: 227,
    text: "The pilot showed great **fortitude** during the emergency landing.",
    options: ["fear", "courage", "skill", "speed", "hesitation"],
    correct: 1,
    explanation: "Fortitude means courage in pain or adversity."
  },
  {
    id: 228,
    text: "The general gave a **concise** summary of the strategic situation.",
    options: ["lengthy", "brief", "detailed", "vague", "technical"],
    correct: 1,
    explanation: "Concise means giving a lot of information clearly and in few words; brief but comprehensive."
  },
  {
    id: 229,
    text: "The recruit's response was deemed **impertinent** by the drill instructor.",
    options: ["respectful", "rude", "quick", "honest", "delayed"],
    correct: 1,
    explanation: "Impertinent means not showing proper respect; rude."
  },
  {
    id: 230,
    text: "The intelligence officer tried to **ascertain** the enemy's position.",
    options: ["guess", "determine", "ignore", "report", "question"],
    correct: 1,
    explanation: "Ascertain means to find out for certain; make sure of."
  },
  {
    id: 231,
    text: "The squadron leader was known for his **magnanimous** treatment of mistakes.",
    options: ["harsh", "generous", "fair", "quick", "public"],
    correct: 1,
    explanation: "Magnanimous means generous or forgiving, especially toward a rival or less powerful person."
  },
  {
    id: 232,
    text: "The officer's testimony was deemed **credible** by the investigation board.",
    options: ["false", "believable", "lengthy", "written", "detailed"],
    correct: 1,
    explanation: "Credible means able to be believed; convincing."
  },
  {
    id: 233,
    text: "The weather conditions were deemed **adverse** for the training flight.",
    options: ["favorable", "unfavorable", "normal", "changing", "stable"],
    correct: 1,
    explanation: "Adverse means preventing success or development; harmful or unfavorable."
  },
  {
    id: 234,
    text: "The platoon demonstrated exemplary **cohesion** during the operation.",
    options: ["division", "unity", "speed", "skill", "discipline"],
    correct: 1,
    explanation: "Cohesion means the action or fact of forming a united whole."
  },
  {
    id: 235,
    text: "The lieutenant's assessment of the situation was quite **astute**.",
    options: ["foolish", "shrewd", "lengthy", "written", "delayed"],
    correct: 1,
    explanation: "Astute means having or showing an ability to accurately assess situations and turn them to advantage."
  },
  {
    id: 236,
    text: "The commander found the excuse to be **dubious** at best.",
    options: ["certain", "doubtful", "acceptable", "creative", "honest"],
    correct: 1,
    explanation: "Dubious means hesitating or doubting; not to be relied upon; suspect."
  },
  {
    id: 237,
    text: "The airman's conduct was **exemplary** throughout his tour of duty.",
    options: ["poor", "commendable", "average", "inconsistent", "questionable"],
    correct: 1,
    explanation: "Exemplary means serving as a desirable model; very good."
  },
  {
    id: 238,
    text: "The general's response to the crisis was both swift and **judicious**.",
    options: ["reckless", "wise", "delayed", "aggressive", "defensive"],
    correct: 1,
    explanation: "Judicious means having, showing, or done with good judgment or sense."
  },
  {
    id: 239,
    text: "The mission parameters were very **stringent** and allowed no deviation.",
    options: ["flexible", "strict", "simple", "complex", "optional"],
    correct: 1,
    explanation: "Stringent means strict, precise, and exacting."
  },
  {
    id: 240,
    text: "The platoon leader showed great **acumen** in tactical situations.",
    options: ["confusion", "insight", "courage", "speed", "hesitation"],
    correct: 1,
    explanation: "Acumen means the ability to make good judgments and quick decisions."
  },
  {
    id: 241,
    text: "The investigation revealed a **flagrant** violation of protocol.",
    options: ["minor", "obvious", "technical", "accidental", "hidden"],
    correct: 1,
    explanation: "Flagrant means conspicuously or obviously offensive; blatant."
  },
  {
    id: 242,
    text: "The officer's decision proved to be **detrimental** to unit morale.",
    options: ["beneficial", "harmful", "popular", "quick", "difficult"],
    correct: 1,
    explanation: "Detrimental means tending to cause harm."
  },
  {
    id: 243,
    text: "The sergeant maintained a **steadfast** commitment to his duties.",
    options: ["wavering", "firm", "minimal", "excessive", "reluctant"],
    correct: 1,
    explanation: "Steadfast means resolutely or dutifully firm and unwavering."
  },
  {
    id: 244,
    text: "The cadet's answer to the question was rather **cryptic**.",
    options: ["clear", "mysterious", "lengthy", "accurate", "simple"],
    correct: 1,
    explanation: "Cryptic means having a meaning that is mysterious or obscure."
  },
  {
    id: 245,
    text: "The commander wanted to **forestall** any potential problems.",
    options: ["cause", "prevent", "identify", "report", "ignore"],
    correct: 1,
    explanation: "Forestall means to prevent or obstruct by taking action ahead of time."
  },
  {
    id: 246,
    text: "The pilot's actions during the crisis were nothing short of **valiant**.",
    options: ["cowardly", "brave", "quick", "calculated", "reckless"],
    correct: 1,
    explanation: "Valiant means showing courage or determination; brave."
  },
  {
    id: 247,
    text: "The training exercise was designed to simulate an **imminent** threat.",
    options: ["distant", "immediate", "foreign", "nuclear", "minor"],
    correct: 1,
    explanation: "Imminent means about to happen; impending."
  },
  {
    id: 248,
    text: "The officer's explanation helped **elucidate** the complex strategy.",
    options: ["confuse", "clarify", "simplify", "question", "implement"],
    correct: 1,
    explanation: "Elucidate means to make something clear; explain."
  },
  {
    id: 249,
    text: "The general showed great **foresight** in his strategic planning.",
    options: ["hindsight", "anticipation", "courage", "experience", "caution"],
    correct: 1,
    explanation: "Foresight means the ability to predict or plan for the future."
  },
  {
    id: 250,
    text: "The enemy's position was considered virtually **impregnable**.",
    options: ["weak", "unconquerable", "visible", "isolated", "fortified"],
    correct: 1,
    explanation: "Impregnable means unable to be captured or broken into; invulnerable."
  },
{
    id: 251,
    text: "The reconnaissance team moved with utmost **stealth** through enemy territory.",
    options: ["noise", "secrecy", "speed", "caution", "difficulty"],
    correct: 1,
    explanation: "Stealth means cautious and surreptitious action or movement."
  },
  {
    id: 252,
    text: "The captain's leadership style was notably **autocratic**.",
    options: ["democratic", "dictatorial", "flexible", "relaxed", "collaborative"],
    correct: 1,
    explanation: "Autocratic means relating to a ruler who has absolute power; domineering."
  },
  {
    id: 253,
    text: "The airman's conduct was deemed **reprehensible** by the review board.",
    options: ["admirable", "blameworthy", "acceptable", "professional", "unusual"],
    correct: 1,
    explanation: "Reprehensible means deserving censure or condemnation; very bad."
  },
  {
    id: 254,
    text: "The intelligence report contained mostly **superfluous** information.",
    options: ["essential", "unnecessary", "classified", "accurate", "recent"],
    correct: 1,
    explanation: "Superfluous means unnecessary, especially through being more than enough."
  },
  {
    id: 255,
    text: "The colonel's instructions were deliberately **vague** to allow flexibility.",
    options: ["specific", "unclear", "written", "verbal", "detailed"],
    correct: 1,
    explanation: "Vague means of uncertain, indefinite, or unclear character or meaning."
  },
  {
    id: 256,
    text: "The soldier's testimony helped to **exonerate** his fellow squad member.",
    options: ["convict", "clear", "identify", "question", "support"],
    correct: 1,
    explanation: "Exonerate means to absolve someone from blame for a fault or wrongdoing."
  },
  {
    id: 257,
    text: "The general was known for his **benevolent** treatment of prisoners.",
    options: ["cruel", "kind", "fair", "strict", "indifferent"],
    correct: 1,
    explanation: "Benevolent means well meaning and kindly."
  },
  {
    id: 258,
    text: "The briefing officer tried to **mitigate** concerns about the operation.",
    options: ["increase", "lessen", "ignore", "address", "hide"],
    correct: 1,
    explanation: "Mitigate means to make less severe, serious, or painful."
  },
  {
    id: 259,
    text: "The squadron's performance has been consistently **mediocre** this quarter.",
    options: ["excellent", "average", "poor", "improving", "declining"],
    correct: 1,
    explanation: "Mediocre means of only moderate quality; not very good."
  },
  {
    id: 260,
    text: "The officer showed great **restraint** despite the provocative remarks.",
    options: ["anger", "self-control", "confusion", "agreement", "hostility"],
    correct: 1,
    explanation: "Restraint means self-control; the ability to control one's emotions or actions."
  },
  {
    id: 261,
    text: "The mission objective seemed nearly **insurmountable** at first.",
    options: ["easy", "impossible", "simple", "dangerous", "unclear"],
    correct: 1,
    explanation: "Insurmountable means too great to be overcome; impossible to surmount."
  },
  {
    id: 262,
    text: "The commander's attitude toward safety was quite **lax**.",
    options: ["strict", "careless", "reasonable", "excessive", "professional"],
    correct: 1,
    explanation: "Lax means not sufficiently strict, severe, or careful."
  },
  {
    id: 263,
    text: "The lieutenant attempted to **reconcile** the conflicting reports.",
    options: ["separate", "harmonize", "ignore", "investigate", "file"],
    correct: 1,
    explanation: "Reconcile means to make compatible or consistent; bring into agreement."
  },
  {
    id: 264,
    text: "The pilot's maneuver was both **audacious** and effective.",
    options: ["timid", "bold", "simple", "dangerous", "standard"],
    correct: 1,
    explanation: "Audacious means showing a willingness to take surprisingly bold risks; daring."
  },
  {
    id: 265,
    text: "The investigation uncovered a **systematic** pattern of negligence.",
    options: ["random", "methodical", "minor", "recent", "accidental"],
    correct: 1,
    explanation: "Systematic means done or acting according to a fixed plan or system; methodical."
  },
  {
    id: 266,
    text: "The general remained **impartial** during the dispute between officers.",
    options: ["biased", "neutral", "angry", "supportive", "involved"],
    correct: 1,
    explanation: "Impartial means treating all rivals or disputants equally; fair and just."
  },
  {
    id: 267,
    text: "The enemy forces began to **capitulate** after weeks of resistance.",
    options: ["attack", "surrender", "retreat", "advance", "regroup"],
    correct: 1,
    explanation: "Capitulate means to cease to resist an opponent or demand; surrender."
  },
  {
    id: 268,
    text: "The squadron leader's remarks were rather **disparaging** toward the new recruits.",
    options: ["praising", "belittling", "encouraging", "neutral", "instructive"],
    correct: 1,
    explanation: "Disparaging means expressing the opinion that something is of little worth; derogatory."
  },
  {
    id: 269,
    text: "The briefing provided a **comprehensive** overview of the situation.",
    options: ["partial", "complete", "brief", "technical", "classified"],
    correct: 1,
    explanation: "Comprehensive means complete; including all or nearly all elements or aspects."
  },
  {
    id: 270,
    text: "The officer's demeanor suggested he was quite **complacent** about security.",
    options: ["worried", "self-satisfied", "vigilant", "concerned", "active"],
    correct: 1,
    explanation: "Complacent means showing smug or uncritical satisfaction with oneself or one's achievements."
  },
  {
    id: 271,
    text: "The intelligence suggested the threat was largely **hypothetical**.",
    options: ["real", "theoretical", "immediate", "serious", "foreign"],
    correct: 1,
    explanation: "Hypothetical means based on or serving as a hypothesis; supposed but not necessarily real."
  },
  {
    id: 272,
    text: "The airman's version of events proved to be **fallacious**.",
    options: ["true", "false", "detailed", "confusing", "incomplete"],
    correct: 1,
    explanation: "Fallacious means based on a mistaken belief; containing a fallacy."
  },
  {
    id: 273,
    text: "The squadron maintained their **resolve** despite adverse conditions.",
    options: ["fear", "determination", "discipline", "training", "equipment"],
    correct: 1,
    explanation: "Resolve means firm determination to do something."
  },
  {
    id: 274,
    text: "The commanding officer was known for his **pragmatic** approach to problems.",
    options: ["theoretical", "practical", "creative", "aggressive", "cautious"],
    correct: 1,
    explanation: "Pragmatic means dealing with things sensibly and realistically in a way based on practical considerations."
  },
  {
    id: 275,
    text: "The recruit's excuse was **implausible** and unconvincing.",
    options: ["believable", "unbelievable", "lengthy", "honest", "creative"],
    correct: 1,
    explanation: "Implausible means not seeming reasonable or probable; failing to convince."
  },
{
    id: 276,
    text: "The general tried to **placate** the concerns of the worried troops.",
    options: ["increase", "calm", "ignore", "address", "dismiss"],
    correct: 1,
    explanation: "Placate means to make someone less angry or hostile; pacify or appease."
  },
  {
    id: 277,
    text: "The mission required absolute **adherence** to the established protocols.",
    options: ["violation", "compliance", "understanding", "review", "modification"],
    correct: 1,
    explanation: "Adherence means attachment or commitment to a person, cause, or belief; faithful observance."
  },
  {
    id: 278,
    text: "The officer's behavior during the crisis was absolutely **deplorable**.",
    options: ["admirable", "shameful", "brave", "cautious", "appropriate"],
    correct: 1,
    explanation: "Deplorable means deserving strong condemnation; shockingly bad in quality."
  },
  {
    id: 279,
    text: "The lieutenant showed remarkable **resilience** after the setback.",
    options: ["weakness", "toughness", "anger", "sadness", "confusion"],
    correct: 1,
    explanation: "Resilience means the capacity to recover quickly from difficulties; toughness."
  },
  {
    id: 280,
    text: "The captain's decision to abort the mission was quite **contentious**.",
    options: ["popular", "controversial", "quick", "wise", "standard"],
    correct: 1,
    explanation: "Contentious means causing or likely to cause an argument; controversial."
  },
  {
    id: 281,
    text: "The colonel attempted to **substantiate** his claims with evidence.",
    options: ["deny", "prove", "hide", "question", "withdraw"],
    correct: 1,
    explanation: "Substantiate means to provide evidence to support or prove the truth of something."
  },
  {
    id: 282,
    text: "The general's strategy was **predicated** on accurate intelligence.",
    options: ["independent", "based", "opposed", "unrelated", "similar"],
    correct: 1,
    explanation: "Predicated means based on or depending on something; stated or asserted."
  },
  {
    id: 283,
    text: "The training officer was quite **adept** at handling difficult situations.",
    options: ["poor", "skilled", "slow", "hesitant", "inexperienced"],
    correct: 1,
    explanation: "Adept means very skilled or proficient at something."
  },
  {
    id: 284,
    text: "The enemy's defensive position appeared **formidable** from a distance.",
    options: ["weak", "intimidating", "visible", "hidden", "abandoned"],
    correct: 1,
    explanation: "Formidable means inspiring fear or respect through being impressively powerful or capable."
  },
  {
    id: 285,
    text: "The report contained several **blatant** errors in the data analysis.",
    options: ["subtle", "obvious", "technical", "minor", "mathematical"],
    correct: 1,
    explanation: "Blatant means done openly and unashamedly; completely lacking in subtlety; obvious."
  },
  {
    id: 286,
    text: "The squadron leader tried to **bolster** morale before the deployment.",
    options: ["lower", "strengthen", "measure", "ignore", "question"],
    correct: 1,
    explanation: "Bolster means to support or strengthen; prop up."
  },
  {
    id: 287,
    text: "The airman's testimony served to **vindicate** his commanding officer.",
    options: ["accuse", "justify", "question", "support", "contradict"],
    correct: 1,
    explanation: "Vindicate means to clear someone of blame or suspicion; show or prove to be right."
  },
  {
    id: 288,
    text: "The mission briefing was intentionally **succinct** to save time.",
    options: ["lengthy", "brief", "detailed", "confusing", "technical"],
    correct: 1,
    explanation: "Succinct means briefly and clearly expressed; concise."
  },
  {
    id: 289,
    text: "The colonel's management style was notably **lenient** with junior officers.",
    options: ["strict", "permissive", "fair", "harsh", "inconsistent"],
    correct: 1,
    explanation: "Lenient means permissive, merciful, or tolerant; not strict or severe."
  },
  {
    id: 290,
    text: "The intelligence officer tried to **discern** the enemy's true intentions.",
    options: ["ignore", "perceive", "guess", "question", "report"],
    correct: 1,
    explanation: "Discern means to perceive or recognize something; distinguish with difficulty."
  },
  {
    id: 291,
    text: "The general's memoirs provided a **candid** account of the campaign.",
    options: ["dishonest", "honest", "brief", "detailed", "classified"],
    correct: 1,
    explanation: "Candid means truthful and straightforward; frank and sincere."
  },
  {
    id: 292,
    text: "The pilot maintained an altitude that was **optimal** for fuel efficiency.",
    options: ["minimum", "best", "maximum", "average", "safe"],
    correct: 1,
    explanation: "Optimal means best or most favorable; most conducive to a favorable outcome."
  },
  {
    id: 293,
    text: "The officer's explanation was filled with **verbose** technical jargon.",
    options: ["brief", "wordy", "clear", "simple", "accurate"],
    correct: 1,
    explanation: "Verbose means using or expressed in more words than are needed; lengthy and wordy."
  },
  {
    id: 294,
    text: "The squadron faced **inevitable** delays due to the weather.",
    options: ["avoidable", "unavoidable", "minor", "major", "unexpected"],
    correct: 1,
    explanation: "Inevitable means certain to happen; unavoidable."
  },
  {
    id: 295,
    text: "The cadet showed great **aptitude** for mechanical systems.",
    options: ["difficulty", "talent", "interest", "training", "experience"],
    correct: 1,
    explanation: "Aptitude means a natural ability or talent; capacity for learning."
  },
  {
    id: 296,
    text: "The general sought to **perpetuate** the unit's traditions and values.",
    options: ["end", "continue", "change", "question", "document"],
    correct: 1,
    explanation: "Perpetuate means to make something continue indefinitely; preserve from oblivion."
  },
  {
    id: 297,
    text: "The lieutenant's argument was very **cogent** and well-reasoned.",
    options: ["weak", "convincing", "lengthy", "emotional", "complex"],
    correct: 1,
    explanation: "Cogent means clear, logical, and convincing; powerfully persuasive."
  },
  {
    id: 298,
    text: "The maintenance chief was very **meticulous** in his inspections.",
    options: ["careless", "careful", "quick", "thorough", "slow"],
    correct: 1,
    explanation: "Meticulous means showing great attention to detail; very careful and precise."
  },
  {
    id: 299,
    text: "The officer attempted to **alleviate** the troops' concerns about the mission.",
    options: ["worsen", "reduce", "ignore", "address", "dismiss"],
    correct: 1,
    explanation: "Alleviate means to make suffering, deficiency, or a problem less severe."
  },
  {
    id: 300,
    text: "The enemy's tactics were designed to be deliberately **provocative**.",
    options: ["peaceful", "inflammatory", "defensive", "confusing", "traditional"],
    correct: 1,
    explanation: "Provocative means causing annoyance, anger, or another strong reaction; deliberately provoking."
  }
];

export const WORD_KNOWLEDGE_CONFIG = {
  timeLimit: 5 * 60, // 5 minutes
  sectionName: "Word Knowledge",
  totalQuestions: 200
};